import { ReactNode } from 'react';

export interface IFeedbackSectionApprovedOptions {
  illustration: ReactNode;
  textContent: {
    description: string;
    subHeading?: {
      amount: string;
      amountType: string;
      currency: string;
    };
    title: string;
  };
}

interface IFeedbackSectionApprovedProps
  extends IFeedbackSectionApprovedOptions {}

/**
 * -----------------------------------------------------------------------------
 * It renders a accepted feedback section with a illustration and text content
 */
export function FeedbackSectionApproved({
  illustration,
  textContent,
}: Readonly<IFeedbackSectionApprovedProps>) {
  const { description, title, subHeading } = textContent;
  const { amountType, currency, amount } = subHeading || {};

  return (
    <div
      className="
        flex items-center justify-center border-b border-t border-gray-50
        px-4 py-5
      "
    >
      <div className="flex flex-col items-center gap-2 sm:flex-row">
        <div className="max-w-48">{illustration}</div>
        <div className="text-center">
          <div
            className="
              text-base uppercase tracking-widest text-gray-900
            "
          >
            {title}
          </div>

          {subHeading ? (
            <div
              className="
                inline-flex flex-col gap-1 pt-2 text-lg font-bold
                text-green-700 sm:flex-row
              "
            >
              <div>{amountType}</div>
              <div className="font-normal">{currency}</div>
              <div>{amount}</div>
            </div>
          ) : null}
          <div className="max-w-72 pt-2 text-xs text-green-800">
            {description}
          </div>
        </div>
      </div>
    </div>
  );
}
